import { render } from "./PromotionCenter.vue?vue&type=template&id=1f6d4e6f&scoped=true"
import script from "./PromotionCenter.vue?vue&type=script&lang=js"
export * from "./PromotionCenter.vue?vue&type=script&lang=js"

import "./PromotionCenter.vue?vue&type=style&index=0&id=1f6d4e6f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6d4e6f"]])

export default __exports__